<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
        <v-overlay :value="isAutoSaving" z-index="9999" opacity="0.8" v-if="AutoSave">
          <div class="text-center d-flex flex-column align-center justify-center">
            <atom-spinner :animation-duration="1500" :size="100" class="mx-auto" color="#038118"/>
            <h3 class="mt-4 green--text">در حال ذخیره سازی خودکار...</h3>
            <p class="green--text mt-2">لطفاً چند لحظه صبر کنید</p>
          </div>
        </v-overlay>

       <qr-edit-gateway
      v-model="showGatewayPopup"
      :sections="specialInfoSingle"
      :form-data="data"
      @edit-all="handleEditAll"
      @save="qrUpdate(true)"
      @cancel="onCancel"
    >
    <template v-slot:preview style="position: relative; min-height: 100%;">
      <div class="sticky-preview">
          <component :is="data.designSettings.theme" v-model="data" :orders.sync="data.orders"/>
        </div>
    </template>
    </qr-edit-gateway>
      <v-row class="mx-auto pa-2" no-gutters v-if="!showGatewayPopup">
        <v-col
          class="pa-2 sticky-md"
          cols="12"
          md="4"
          style="top: 100px; height: fit-content"
        >
        <component :is="data.designSettings.theme" v-model="data"  :orders.sync="data.orders"/>
        </v-col>

        <v-col cols="12" md="8">
          <v-card :disabled="loading" flat>
            <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
              <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
                <div class="row justify-center">
                  <div class="col-md-12">
                    <p>وارد کردن اطلاعات سوشال مدیا</p>
                  </div>
                  <div class="col-md-6 mt-0 pt-0">
                    <div class="rowinfo">
                      <v-text-field
                        v-model="data.visitName"
                        :disabled="e6 > 1"
                        append-icon="mdi-pen"
                        class="mt-0 pt-0"
                        clear-icon="mdi-close-circle-outline"
                        clearable
                        dense
                        label="نام کانال اجتماعی"
                        outlined
                      />
                      <help-info
                        :element-name="`${serviceName}-${componentName}-res-title`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        label="نام کانال اجتماعی"
                      />
                    </div>
                  </div>
                  <div class="col-md-6 mt-0 pt-0">
                    <div class="rowinfo">
                      <qr-address-field
                        id="qr-address"
                        v-model="res.identifier"
                        :domain-id="res.domain_id"
                        :error-messages="errors['identifier']"
                        append-icon="mdi-web"
                        class="mt-0 pt-0 contentinfo"
                        dense
                        :key="$t('qrAddressUpdate.hints.allowedChars')"
                        :hint="$t('qrAddressUpdate.hints.allowedChars')"
                        outlined
                        persistent-hint
                        readonly
                      />
                      <help-info
                        :element-name="`${serviceName}-${componentName}-res-identifier`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        label="آدرس کیوآر"
                      />
                    </div>
                  </div>
                </div>
              </v-stepper-step>
              <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
              <div class="mb-4">
                <!-- سوییچ و آیکون راهنما -->
                <div class="d-flex align-center">
                  <v-switch
                    v-model="AutoSave"
                    color="primary"
                    class="mt-0 pt-0 shrink"
                    hide-details
                    label="ذخیره خودکار"
                  ></v-switch>

                  <!-- آیکون راهنما با Tooltip (هاور برای دسکتاپ و تاچ برای موبایل) -->
                  <v-tooltip bottom max-width="320">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        x-small
                        class="mr-1"
                        v-bind="attrs"
                        v-on="on"
                        @click.stop
                      >
                        <v-icon small color="grey darken-1">
                          mdi-help-circle-outline
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>
                      تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                    </span>
                  </v-tooltip>
                </div>

                <!-- متن کم‌رنگ و ظریف اختصاصی برای موبایل (زیر سوییچ) -->
                <div
                  v-if="$vuetify.breakpoint.xsOnly"
                  class="text-caption grey--text text--darken-1 mt-1 pr-1"
                  style="line-height: 1.4"
                >
                  تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                </div>
              </div>

                <list-expansion
                  flat
                  icon="pencil-ruler"
                  single
                  :title="$t('select_template_design')"
                    @save-required="AutoSave && qrUpdate(false)"

                  >
                  <template v-slot:content>
                  <theme-layout-selector v-model="data.designSettings" />
                  </template>
                </list-expansion>

                <list-expansion
                  v-model="data"
                  :components="specialInfo"
                  :data="data"
                  flat
                  @save-required="AutoSave && qrUpdate(false)"
                />

                <div class="col-md-12">
                  <next-btn
                    :loading="loading"
                    style="background: #1b8d39"
                    @click="qrUpdate(true)"
                  />
                </div>
              </v-stepper-content>
            </v-stepper>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import QrMaker from "@/view/pages/qrland/components/qrMaker";
import socialMobile1_ok from "@/view/pages/otherQrTypes/socialMedia/component/socialMobile1_ok.vue";
import socialMobile2_ok from "@/view/pages/otherQrTypes/socialMedia/component/socialMobile2_ok.vue";
import socialMobile3_ok from "@/view/pages/otherQrTypes/socialMedia/component/socialMobile3_ok.vue";
import socialMobile4_ok from "@/view/pages/otherQrTypes/socialMedia/component/socialMobile4_ok.vue";
import QrAddressField from "@/view/content/fragments/qrAddressField";
import ListExpansion from "@/view/content/fragments/listExpansion";
import NextBtn from "@/view/content/fragments/nextBtn";
import QrManagement from "@/view/pages/qrland/components/qrManage/qrManagement";
import PrevBtn from "@/view/content/fragments/prevBtn";
import { Bus } from "@/main";
import { mapActions } from "vuex";
import QrEditGateway from "../../qrland/components/QrEditGateway.vue";
import ThemeLayoutSelector from "./ThemeLayoutSelector.vue";
import { AtomSpinner } from "epic-spinners";


export default {
  name: "editSocial",

  components: {
    PrevBtn,
    QrManagement,
    NextBtn,
    ListExpansion,
    QrAddressField,
    socialMobile1_ok,
    socialMobile2_ok,
    socialMobile3_ok,
    socialMobile4_ok,
    QrMaker,
    QrEditGateway,
    ThemeLayoutSelector,
    AtomSpinner
  },

  data() {
    return {
      AutoSave:false,
      isAutoSaving: false, 
      orders: [],
      showGatewayPopup: this.$route?.query?.gateway === 'true',
      helpData: [],
      serviceName: "Qrland",
      componentName: "editSocial",

      e6: 1,
      qrShow: 1,
      svgMade: "",
      destinationUrl: "",
      createdId: null,
      dtUrl: null,
      shortId: null,
      showDialog: true,
      loading: false,
      errors: {},
      data: {
        designSettings: {
          theme: null,
          layout: null
        },
        orders: []
      },
      res: {},
      qrDesign: {},
      cons: { title: "دانلود کیوآر" },
    };
  },

  mounted() {
    this.fetchData();
    Bus.$on("socialMedias", (value) => {
      this.data.socialMedia = value;
    });
  },  computed: {
        specialInfo() {
          return [
            {
              name: "bannerSelector",
              value: "",
              title: this.$t("edit_bpage_special_info_special.upload_image"),
              icon: "image",
              model: "banner",
            },
            {
              name: "baseInfo",
              value: "",
              title: this.$t("edit_bpage_special_info_special.information"),
              icon: "account-outline",
            },
              {
              name: "customerClubSettings",
              title: this.$t("sms_membership_message"),
              icon: "cellphone-message",
              model: "customerClub",
            },

            {
              name: "imageUploader",
              value: "",
              title: this.$t("edit_bpage_special_info_special.upload_logo"),
              icon: "image",
              model: "photo",
            },
            {
              name: "socialMediaIcons",
              value: "",
              title: this.$t("edit_bpage_special_info_special.add_social_media"),
              subtitle: "",
              icon: "instagram",
              model: "socialMedia",
            },
          ];
        },
    specialInfoSingle() {
      return [
        {
          name: "bannerSelector",
          value: "",
          title: this.$t(
            "edi_social_special_info_single.banner_selector_title"
          ),
          icon: "image",
          model: "banner",
          description: this.$t(
        "edi_social_special_info_single.banner_selector_description")
        },
        {
          name: "baseInfo",
          value: "",
          title: this.$t(
            "edi_social_special_info_single.base_info_title"
          ),
          icon: "account-outline",
          description: this.$t(
            "edi_social_special_info_single.base_info_description"
          ),        
        },
        {
          name: "customerClubSettings",
          title: this.$t("sms_membership_message"),
          icon: "cellphone-message",
          model: "customerClub",
        },
        {
          name: "imageUploader",
          value: "",
          title: this.$t(
            "edi_social_special_info_single.image_uploader_title"
          ),
          icon: "image",
          model: "photo",
          description: this.$t(
            "edi_social_special_info_single.image_uploader_description"
          ),
        },
        {
          name: "socialMediaIcons",
          value: "",
          title: this.$t(
            "edi_social_special_info_single.social_media_icons_title"
          ),
          subtitle: "",
          icon: "instagram",
          model: "socialMedia",
          description: this.$t(
            "edi_social_special_info_single.social_media_icons_description"
          ),
    },
      ];
    },
    domainName() {
      return this.$route.params?.name?.replace('?gateway=true','');
    },
    qrId() {
      return this.$route.params?.id?.replace('?gateway=true','');
    },
  },


  methods: {
    ...mapActions("localstorage", ["setCreatedQrID"]),
      onCancel() {
      this.goto('qr/list');
    },
    handleEditAll() {
      this.showGatewayPopup = false;
    },

      fetchData() {
      this.loading = true;
      this.$api
        .get(
          `/v1/testQr/find/${this.domainName}${
            !!this.qrId ? "/" + this.qrId : ""
          }`
        )
        .then(({ data }) => {
          this.setCreatedQrID(data.data.id);

          let info = data.data.data.data || {};

          if (!info.orders || info?.orders?.length === 0) {
            this.$set(info, 'orders', [        
              { name: 'banner' },
              { name: 'profile' },
              { name: 'about' },
              { name: 'socialMedia' },
          ]);
          }
          if(!info?.customerClub)
          {
            info.customerClub= {
                configs: {
                  patternId: 499,
                  smsType: "pattern",
                  isActive: true,
                  message: {
                    data1: {
                      text: "name",
                      state: "userInfo",
                    },
                    data2: {
                      text: "lastName",
                      state: "userInfo",
                    },
                  },
                },
                title: "عضویت در باشگاه مشتریان",
                description: "این یک باشگاه مشتریان عادی نیست!\nشمارتو ثبت کن",
              };
          }
          if (!info?.designSettings) {
            info.designSettings = {
              theme: "socialMobile4_ok",
              layout: "SocialGrid2"
            };
          }

          this.data = info;
          this.res = data.data;
        })
        .catch(({ response }) => {
          this.$toast.error("خطا در دریافت اطلاعات!");
          console.log("error in get social data: ", response);
        })
        .finally(() => (this.loading = false));
    },

    qrUpdate(final = false) {
       if (final || !this.AutoSave) {
        this.loading = true;
      } else {
        this.isAutoSaving = true;
      }
      const data = new FormData();
      data.append("type", "SocialMedia");
      data.append("qrType", "dynamic");
      data.append("domain", this.res.domain.name);
      data.append("identifier", this.res.identifier);
      data.append("qr_id", this.res.qrId);
      data.append("_method", "PUT");
      data.append("title", this.data.visitName);

      data.append(
        "data",
        JSON.stringify({
          theme: "",
          data: this.data,
        }),
      );

      this.$api
        .post("/v1/testQr/update", data, {
          headers: {
            "Content-Type": "application/from-data",
          },
        })
        .then((res) => {
        if (final)
          {
          this.$toast.success("شبکه های اجتماعی شماباموفقیت ویرایش شد.");
          this.goto("qr/list");
          }
        })
        .catch((err) => {
          this.loading = false;
          this.isAutoSaving =false;

        })
        .finally(() => {
          this.loading = false;
         this.isAutoSaving =false;

        });
    },
  },
};
</script>

<style scoped></style>
